import push from "./push";

/**
 * Sends a `facebookInit` event for Google Tag Manager
 * https://developers.google.com/tag-manager/devguide#multipush
 */
export default function pushFacebookInit(
    facebookPixelId: string | null
): Promise<void> {
    return push("facebookInit", {
        "facebook-pixel-id": facebookPixelId
    });
}
